/* === Sika-Design product gallery layout override === */
document.addEventListener('DOMContentLoaded', () => {
  const dots = document.querySelector('.page-dots');
  const il = document.querySelector('.product-gallery__image-list');
  if (dots && il && dots.parentElement !== il) {
    il.appendChild(dots);
  }
});


/* ### Sika-Design product + lifestyle gallery loop (wrap arrows) ### */
(function(){
  function patch(sc){
    if(sc.__sdLoop) return; sc.__sdLoop = true;
    var on = sc.next.bind(sc), op = sc.previous.bind(sc);
    sc.next = function(o){ if(sc.cells && sc.selectedIndex >= sc.cells.length - 1){ sc.select(0, o||{}); } else { on(o); } };
    sc.previous = function(o){ if(sc.cells && sc.selectedIndex <= 0){ sc.select(sc.cells.length - 1, o||{}); } else { op(o); } };
    var reEnable = function(){ document.querySelectorAll('[aria-controls="' + sc.id + '"]').forEach(function(el){ var b = el.querySelector('button'); if(b) b.disabled = false; }); };
    sc.addEventListener('scroll:edge-nearing', reEnable);
    sc.addEventListener('scroll:edge-leaving', reEnable);
    reEnable();
  }
  function patchAll(){ document.querySelectorAll('scroll-carousel.product-gallery__carousel, scroll-carousel.product-projects__carousel').forEach(patch); }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', patchAll); } else { patchAll(); }
  var scheduled = false;
  var mo = new MutationObserver(function(){ if(scheduled) return; scheduled = true; setTimeout(function(){ scheduled = false; patchAll(); }, 200); });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
